import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import hi from "./locales/hi.json";

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			en: { translation: en },
			hi: { translation: hi },
		},
		fallbackLng: "en",
		returnObjects: false,
		interpolation: {
			escapeValue: false,
		},
	});

export default i18n;
